import Cart from "../components/Cart";
import PageTitle from "../components/ui/PageTitle";


export default function Checkout() {

  return (
    <>
      <PageTitle>Your new friends!</PageTitle>
      <Cart />
    </>
  );

}
